exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.bigbigbutton {\r\n  margin-top: 100px;\n}\r\n", "", {"version":3,"sources":["D:/java/social-training/省内平台手机/src/view/clearAll.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;CACnB","file":"clearAll.vue","sourcesContent":["\r\n.bigbigbutton {\r\n  margin-top: 100px;\r\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e60fa35","scoped":false,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/clearAll.vue
// module id = WjXO
// module chunks = 49